var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gaugeEl",staticClass:"compliance-gauge"})
}
var staticRenderFns = []

export { render, staticRenderFns }